var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "siren-searchbar" },
    [
      _c(
        "div",
        { staticClass: "siren-searchbar__label" },
        [
          _c("CompassIcon", { attrs: { icon: "wand" } }),
          _vm._v(" "),
          _c(
            "label",
            { staticClass: "typographies-paragraph-medium-semibold" },
            [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.$t.__("SirenSearchBar.label")) +
                  "\n        "
              )
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("CompassInput", {
        ref: "sirenSearchBarInput",
        attrs: {
          placeholder: _vm.$t.__("SirenSearchBar.placeholder"),
          suffixIcon: "search"
        },
        nativeOn: {
          keydown: function($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])
            ) {
              return null
            }
            $event.stopPropagation()
            $event.preventDefault()
            return _vm.handleCancel($event)
          }
        },
        model: {
          value: _vm.selectedValue,
          callback: function($$v) {
            _vm.selectedValue = $$v
          },
          expression: "selectedValue"
        }
      }),
      _vm._v(" "),
      _c(
        "CompassDropdown",
        {
          directives: [
            {
              name: "click-outside",
              rawName: "v-click-outside",
              value: _vm.handleClickOutside,
              expression: "handleClickOutside"
            }
          ],
          ref: "sirenSearchBarDropdown",
          attrs: {
            isVisible: _vm.showDropdown,
            parentRef: "sirenSearchBarInput",
            dropdownClass: "siren-searchbar-dropdown",
            noResultsLabel: _vm.$t.__("common.labels.no_result"),
            minWidth: _vm.minWidth,
            noResults: _vm.results.length === 0 && !_vm.isLoading
          }
        },
        [
          _vm.isLoading
            ? _vm._l(2, function(n) {
                return _c(
                  "CompassDropdownOption",
                  {
                    key: n,
                    staticClass: "siren-searchbar-dropdown-option--loading",
                    attrs: { value: "", label: "", disabled: true }
                  },
                  [_c("SirenSearchBarLoading")],
                  1
                )
              })
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.results, function(result) {
            return _c(
              "CompassDropdownOption",
              {
                key: result.siret,
                attrs: { label: result.name, value: result.id },
                on: {
                  click: function($event) {
                    return _vm.handleCloseAndCreateNewTaskClick(result)
                  }
                }
              },
              [
                _c("div", { staticClass: "siren-searchbar-dropdown-option" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "siren-searchbar-dropdown-option__title typographies-paragraph-medium-semibold"
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "siren-searchbar-dropdown-option__icon"
                        },
                        [
                          _c("CompassIcon", {
                            attrs: {
                              icon: "building-community",
                              size: "extra-small"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(
                        "\n                    " +
                          _vm._s(result.name) +
                          "\n                "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", [
                    _c(
                      "div",
                      {
                        staticClass:
                          "siren-searchbar-dropdown-option__siret typographies-paragraph-small-regular"
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(result.siret) +
                            "\n                    "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "siren-searchbar-dropdown-option__address typographies-paragraph-small-regular"
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(result.address.address_line_1) +
                            "\n                    "
                        )
                      ]
                    )
                  ])
                ])
              ]
            )
          })
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }